var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_currency") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-127, -273)",
    stroke: "#0E1C39",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(127, 274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,27.8008696 C22.2935827,27.8008696 27.8008696,22.2935827 27.8008696,15.5 C27.8008696,8.70641728 22.2935827,3.19913035 15.5,3.19913035 C8.70641728,3.19913035 3.19913035,8.70641728 3.19913035,15.5",
    id: "\\u692D\\u5706\\u5F62",
    strokeLinecap: "round",
    transform: "translate(15.5, 15.5) rotate(-108) translate(-15.5, -15.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(19.0712, 14.3096)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 5.15842921,
    cy: 1.98401123,
    rx: 5.15842921,
    ry: 1.98401123
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3168584,10.3168584 C10.3168584,9.22111927 8.00735099,8.33284718 5.15842921,8.33284718 C2.30950742,8.33284718 0,9.22111927 0,10.3168584",
    id: "\\u692D\\u5706\\u5F62",
    strokeLinecap: "round",
    transform: "translate(5.1584, 9.3249) scale(1, -1) translate(-5.1584, -9.3249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3168584,7.14244044 C10.3168584,6.04670129 8.00735099,5.15842921 5.15842921,5.15842921 C2.30950742,5.15842921 0,6.04670129 0,7.14244044",
    id: "\\u692D\\u5706\\u5F62",
    strokeLinecap: "round",
    transform: "translate(5.1584, 6.1504) scale(1, -1) translate(-5.1584, -6.1504)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrency);
export default __webpack_public_path__ + "static/media/icon_currency.af2c1fd0a5264eb8077e1eca67249136.svg";
export { ForwardRef as ReactComponent };